export const QUOTE_STATUS: Record<string, { label: string; cls: string }> = {
  draft: { label: "Draft", cls: "bg-gray-100 text-gray-700" },
  pending_approval: { label: "Awaiting approval", cls: "bg-amber-100 text-amber-800" },
  approved: { label: "Approved", cls: "bg-blue-100 text-blue-800" },
  sent: { label: "Sent", cls: "bg-purple-100 text-purple-800" },
  accepted: { label: "Accepted", cls: "bg-green-100 text-green-800" },
  rejected: { label: "Declined", cls: "bg-red-100 text-red-800" },
  expired: { label: "Expired", cls: "bg-orange-100 text-orange-800" },
  converted: { label: "Invoiced", cls: "bg-emerald-100 text-emerald-800" },
  superseded: { label: "Replaced by newer version", cls: "bg-gray-100 text-gray-500" },
};
